import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

let loaded = false;

export const init = (dsn: string) => {
  if (typeof window === 'undefined'){ return; }
  if (loaded) { return; }
  loaded = true;

  if (dsn) {
    Sentry.init({
      enabled: true,
      dsn,
      // @ts-ignore
      integrations: [new Integrations.BrowserTracing()],
      tracesSampleRate: 0.1,
    });
  }
};
